module.exports = __webpack_public_path__ + "static/media/cinemaLogo.e0d6a691.jpg";